import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Drawer, Grid, Tooltip, IconButton } from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';
import AsyncStorage from '@react-native-community/async-storage';

import * as AppActions from '../../store/modules/app/app-actions';
import { AppStateType } from '../../store/modules/root-reducer';
import { THEMES, ISA_THEME } from '../../constants';

import LanguagesDropdown from '../LanguagesDropdown';
import { DemoButton, DemoButtonInner, DemoTitle, Heading, Wrapper } from './styles';

type DemoTypes = {
  title: string;
  theme: string;
};

const Demo: React.FunctionComponent<DemoTypes> = ({ title, theme }) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state: AppStateType) => state.app.theme);

  return (
    <Grid item xs={6}>
      <DemoButton
        active={theme === currentTheme}
        onClick={async () => {
          await AsyncStorage.setItem(ISA_THEME, theme ?? THEMES.DEFAULT);
          dispatch(AppActions.setTheme(theme));
        }}
      >
        <DemoButtonInner selectedTheme={theme} />
      </DemoButton>
      <DemoTitle variant="subtitle2" gutterBottom>
        {title}
      </DemoTitle>
    </Grid>
  );
};

const Demos: React.FunctionComponent<any> = () => {
  return (
    <Wrapper>
      <Heading button={true}>Configurações</Heading>

      <Box px={4} my={3}>
        <LanguagesDropdown />
      </Box>

      <Box px={4} my={3}>
        <Grid container spacing={3}>
          <Demo title="Dark" theme={THEMES.DARK} />
          <Demo title="Light" theme={THEMES.LIGHT} />
          {/* <Demo title="Default" theme={THEMES.DEFAULT} />
          <Demo title="Blue" theme={THEMES.BLUE} />
          <Demo title="Green" theme={THEMES.GREEN} />
          <Demo title="Indigo" theme={THEMES.INDIGO} /> */}
        </Grid>
      </Box>
    </Wrapper>
  );
};

interface SettingsProps {
  isStep1: boolean;
}

const Settings: React.FunctionComponent<any> = ({ isStep1 }: SettingsProps) => {
  const [state, setState] = useState({
    isOpen: false
  });

  const toggleDrawer = (open: boolean) => () => {
    setState({ ...state, isOpen: open });
  };

  return (
    <React.Fragment>
      <Tooltip title="Configurações">
        <IconButton color="inherit" onClick={toggleDrawer(true)} disabled={isStep1}>
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <Drawer anchor="right" open={state.isOpen} onClose={toggleDrawer(false)}>
        <Demos />
      </Drawer>
    </React.Fragment>
  );
};

export default React.memo(Settings);
